import type { IHeatmapModalData } from '../stores';

import { useHeatmapModalStore } from '../stores';
import { useCallback } from 'react';

export interface IHeatmapModalMonitorResult {
  data: IHeatmapModalData | undefined;
  isOpenModal: boolean;
  onCloseModal: () => void;
  onOpenModal: (params: string) => void;
}

export const useHeatmapModalMonitor = (): IHeatmapModalMonitorResult => {
  const data = useHeatmapModalStore((state) => state.data);
  const setOpenModal = useHeatmapModalStore((state) => state.setOpenModal);

  const isOpenModal = data?.open ?? false;

  const onCloseModal = useCallback(() => {
    setOpenModal({ open: false, params: '' });
  }, [setOpenModal]);

  const onOpenModal = useCallback(
    (params: string) => {
      setOpenModal({ open: true, params });
    },
    [setOpenModal],
  );

  return {
    data,
    isOpenModal,
    onOpenModal,
    onCloseModal,
  };
};
